import {
  DataGridPremium,
  DataGridPremiumProps,
} from '@mui/x-data-grid-premium';

import { GroupColumnsPanel } from '~/components/SolaForceDataGrid/components/GroupColumnsPanel';
import { useDataGridGroupStyling } from '~/components/SolaForceDataGrid/useDataGridGroupStyling';

export const SolaForceDataGrid = (props: DataGridPremiumProps) => {
  const { sx, columns, columnGroupingModel, ...passThroughProps } = props;

  const processedProps = useDataGridGroupStyling({
    sx,
    columnGroupingModel,
    columns: [...columns],
  });

  const dataGridProps = {
    disablePivoting: true,
    ...processedProps,
    ...passThroughProps,
  };

  const { slotProps, slots } = dataGridProps;

  return (
    <DataGridPremium
      {...dataGridProps}
      slots={{
        columnsPanel: GroupColumnsPanel,
        ...slots,
      }}
      slotProps={
        slotProps
          ? slotProps
          : {
              columnMenu: {
                slots: {
                  columnMenuPinningItem: null,
                  columnMenuAggregationItem: null,
                  columnMenuGroupingItem: null,
                },
              },
            }
      }
    />
  );
};
